import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {clamp} from 'lodash'

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SliderComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderComponent implements OnInit, ControlValueAccessor {

    @Input() hideInput: boolean;

    @Input() max: number;

    @Input() min: number;

    @Input() step: number = 1;

    public minValue: number;

    public disabled: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
    }

    onChange = (quantity) => {
    };

    onTouched = () => {
    };

    writeValue(quantity: number) {
        this.minValue = quantity;
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }


    onMinInputChange(e) {
        if (!this.disabled) {
            this.minValue = this.clampValue(+e?.target?.value || 0)
            this.onChange(this.minValue)
        }
    }

    onSliderChange(e) {
        if (!this.disabled) {
            this.minValue = this.clampValue(+e?.value || 0)
            this.onChange(this.minValue)
        }
    }

    clampValue(val) {
        const clamped = clamp(+val, this.min, this.max)
        return clamped - clamped % this.step
    }

}
